
import React from 'react';
import { Link } from "react-router-dom";
import { useAuth } from "../../Common/Configurations/AuthContext";
import DefaultData from '../../CompanyData/DefaultData'; // Adjust path if needed

const PackageTabs = (props) => {
  const { user } = useAuth();
  const baseTabStyle = { border: 'none', fontWeight: '500', padding: '0.75rem 1.5rem', borderRadius: '0.375rem 0.375rem 0 0' };
  const inactiveTabStyle = { ...baseTabStyle, backgroundColor: 'transparent', color: DefaultData.THEMECOLOR3, opacity: 2 };
  const activeTabStyle = { ...baseTabStyle, backgroundColor: DefaultData.THEMECOLOR2, color: DefaultData.THEMECOLOR3 };
  const getStyle = (pageName) => (props.pageName === pageName ? activeTabStyle : inactiveTabStyle);

  return (
    <div style={{ backgroundColor: DefaultData.THEMECOLOR5, padding: '0 1rem', borderBottom: `1px solid ${DefaultData.THEMECOLOR2}` }}>
      <ul className="nav nav-tabs" style={{ borderBottom: 'none' }}>
        {user && user.companyType !== "SUPPLIER" && (
          <li className="nav-item">
            <Link to={"/package"} className="nav-link" style={getStyle("HOLIDAY PACKAGE")}>CREATE PACKAGE</Link>
          </li>
        )}
        {user && user.companyType !== "SUPPLIER" && (
          <li className="nav-item" role="presentation">
            <Link to={"/packageslist"} className="nav-link" style={getStyle("PACKAGES")}>PACKAGES</Link>
          </li>
        )}
        {user && user.isWebsite && (
          <li className="nav-item" role="presentation">
            <Link to={"/websitepackages"} className="nav-link" style={getStyle("WEBSITEPACKAGES")}>WEBSITE PACKAGES</Link>
          </li>
        )}
        {/* <li className="nav-item">
            <Link to={"/aisupplierpackage"} className={props.pageName === "AIPACKAGE BUILDER" ? "nav-link active bg-primary text-white" : "nav-link"}>AI PACKAGE BUILDER WITH SUPPLIER</Link>
        </li> */}
        {user && user.companyType !== "SUPPLIER" && (
          <li className="nav-item" role="presentation">
            <Link to={"/ai-packageslist"} className="nav-link" style={getStyle("AI PACKAGES")}>
              AI PACKAGES
            </Link>
          </li>
        )}
         {user && user.companyType !== "SUPPLIER" && (
          <li className="nav-item" role="presentation">
            <Link to={"/dmcpackagesdeals"} className="nav-link" style={getStyle("DMCPACKAGESDEALS")}>
              DMC DEALS
            </Link>
          </li>
        )}
        {user && user.companyType == "SUPPLIER" && (
          <li className="nav-item" role="presentation">
            <Link to={"/dmcpackagecreate"} className="nav-link" style={getStyle("DMCPACKAGECREATE")}>
              DMC PACKAGE CREATE
            </Link>
          </li>
        )}
        {user && user.companyType == "SUPPLIER" && (
          <li className="nav-item" role="presentation">
            <Link to={"/dmcpackageslist"} className="nav-link" style={getStyle("DMCPACKAGESLIST")}>
              DMC PACKAGES LIST
            </Link>
          </li>
        )}
        <li className="nav-item" role="presentation">
          <Link to={"/enquirylist"} className="nav-link" style={getStyle("ENQUIRIES")}>PACKAGE ENQUIRIES</Link>
        </li>

        {/* <li className="nav-item" role="presentation">
            <Link to={"/packagedates"} className={props.pageName === "PACKAGEDATES" ? "nav-link active bg-primary text-white" : "nav-link"}>PACKAGE DATES</Link>
        </li> */}
      </ul>
    </div>
  );
};

export default PackageTabs;